import React from 'react';
import styles from './index.css';
import PropTypes from 'prop-types';
import ShortVideo from './shortVideo';
import ShortPic from './shortPic';

class Short extends React.PureComponent {
    static propTypes = {
        base62Id: PropTypes.string,
    };

    render() {
        let { item } = this.props;

        return (
            item &&
            item.style &&
            item.style.view &&
            (item.style.view === 'wbcommitvideobigimg' ? (
                <ShortVideo content={item} />
            ) : (
                <ShortPic content={item} />
            ))
        );
    }
}

export default Short;
